export const CLINIC = {
  name: "Salud Ocular",
  subtitle: "Instituto Oftalmológico",
  phoneRaw: "543434469966",
  phoneDisplay: "+54 343 446-9966",
  email: "saludocularparana@gmail.com",
  address: "Cervantes 732, Paraná, Entre Ríos",
  schedule: "Lunes a Viernes · 9:00 a 17:00 hs",
  facebook: "https://www.facebook.com/Saludocularparana",
  instagram: "https://www.instagram.com/saludocularparana/",
  mapsEmbed:
    "https://www.google.com/maps?q=Salud+Ocular+Parana&ll=-31.7263739,-60.5394906&z=17&output=embed",
  mapsLink: "https://maps.app.goo.gl/unBym56yA9SmS8heA",
};

export const WHATSAPP_MESSAGE =
  "Hola! Quisiera agendar un turno en Salud Ocular.";

export const whatsappUrl = (msg = WHATSAPP_MESSAGE) =>
  `https://wa.me/${CLINIC.phoneRaw}?text=${encodeURIComponent(msg)}`;

export const DOCTORS = [
  { name: "Dr. Federico Schubert", role: "Médico Oftalmólogo" },
  { name: "Dr. Alejandro Silió", role: "Médico Oftalmólogo" },
];

export const OBRAS_SOCIALES = [
  "OSDE",
  "Swiss Medical",
  "Galeno",
  "OSECAC",
  "Medifé",
  "OSPRERA",
  "Sancor Salud",
  "Accord Salud",
  "PAMI",
  "OSER",
];

export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_ojo-sano-citas/artifacts/sl9eabeq_isologo%20Salud%20ocular.png",
  facade:
    "https://customer-assets.emergentagent.com/job_ad38e406-9bca-4894-a78f-40a48f066b89/artifacts/a027aj2j_DSC01132.JPG",
  equipmentBlue:
    "https://customer-assets.emergentagent.com/job_ad38e406-9bca-4894-a78f-40a48f066b89/artifacts/fcvu3sdp_DSC01158.jpg",
  equipmentOrange:
    "https://customer-assets.emergentagent.com/job_ad38e406-9bca-4894-a78f-40a48f066b89/artifacts/qxxx9iab_DSC01165.JPG",
  extra:
    "https://customer-assets.emergentagent.com/job_ad38e406-9bca-4894-a78f-40a48f066b89/artifacts/p2qunzh7_Archivo_000.jpeg",
  happySeniors:
    "https://images.unsplash.com/photo-1760722531515-a2b2d5013879?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  eyeCloseUp:
    "https://images.unsplash.com/photo-1592505310266-283c3ee21101?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
